import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "header-image no-image"
};
const _hoisted_2 = { class: "header-image-box" };
const _hoisted_3 = { class: "heading container" };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = {
    key: 0,
    class: "dop-search"
};
const _hoisted_6 = ["onSubmit"];
const _hoisted_7 = { class: "dop-input-container" };
const _hoisted_8 = { class: "input-container" };
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { value: "" };
const _hoisted_11 = ["value"];
const _hoisted_12 = {
    type: "submit",
    class: "btn btn-green-light"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--dop" }, null, -1);
const _hoisted_14 = {
    key: 1,
    class: "search"
};
const _hoisted_15 = ["onSubmit"];
const _hoisted_16 = { class: "search-input" };
const _hoisted_17 = ["placeholder"];
const _hoisted_18 = ["title"];
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--search-line" }, null, -1);
const _hoisted_20 = [
    _hoisted_19
];
const _hoisted_21 = { class: "error-info" };
const _hoisted_22 = { class: "container" };
const _hoisted_23 = { class: "search" };
const _hoisted_24 = ["onSubmit"];
const _hoisted_25 = { class: "search-input" };
const _hoisted_26 = ["placeholder"];
const _hoisted_27 = ["aria-label", "title"];
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--close-fill" }, null, -1);
const _hoisted_29 = [
    _hoisted_28
];
const _hoisted_30 = ["title"];
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--search-line" }, null, -1);
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = { value: "" };
const _hoisted_34 = ["value"];
const _hoisted_35 = {
    key: 0,
    class: "error-info"
};
const _hoisted_36 = {
    key: 1,
    class: "dop-results"
};
const _hoisted_37 = { class: "uppercase" };
const _hoisted_38 = {
    key: 0,
    class: "results grid-layout"
};
const _hoisted_39 = ["src", "alt"];
const _hoisted_40 = { class: "name" };
const _hoisted_41 = { class: "path" };
const _hoisted_42 = ["innerHTML"];
const _hoisted_43 = ["href", "title"];
const _hoisted_44 = ["href", "title"];
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--file-text-line" }, null, -1);
const _hoisted_46 = [
    _hoisted_45
];
const _hoisted_47 = ["href"];
const _hoisted_48 = ["href"];
const _hoisted_49 = {
    key: 3,
    class: "no-results"
};
import { onMounted, ref, watch, nextTick } from "vue";
import { __ } from '../js/helpers/i18n';
import axios from '../js/helpers/axiosConfig';
import Pagination from '../vue/Pagination.vue';
import { computed } from 'vue';
import { customSelect } from '../js/functions/custom-forms';
import { asset } from "../js/helpers/others";
export default /*#__PURE__*/ _defineComponent({
    props: {
        enabled: { type: Boolean, required: true },
        autocompleteUrl: { type: String, required: true },
        searchUrl: { type: String, required: true },
        dopLocalesUrl: { type: String, required: true },
        size: { type: String, required: true },
        mode: { type: String, required: true },
        categories: { type: Array, required: true },
        defaultLocale: { type: String, required: true },
        pageTitle: { type: String, required: true }
    },
    setup(__props) {
        const props = __props;
        const query = ref('');
        const category = ref('');
        const index = ref(1);
        const size = ref(0);
        const results = ref([]);
        // const suggestions = ref([])
        const totalPages = ref(0);
        const totalResults = ref(0);
        const noResults = ref(false);
        const lastQuery = ref('');
        const mode = props.mode;
        const categories = props.categories;
        const dopLocales = ref([]);
        const locale = ref('');
        const searchLocale = ref('');
        const searchTimeout = ref();
        const dopRegex = /^DoP-[0-9]{2}-[0-9]{1,16}-[0-9]{2}$/;
        let errorMessage = ref('');
        let placeholder = computed(() => {
            return (props.mode == 'cms_documents_dop') ? __("Nr DoP (np. DoP-16-0001-01)") : __("Wyszukaj...");
        });
        onMounted(async () => {
            size.value = +props.size;
            if (props.mode != 'cms_documents_dop') {
                locale.value = props.defaultLocale;
            }
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('query')) {
                query.value = decodeURI(urlParams.get('query'));
                await initDoPLocales();
                await search();
            }
            else if ((props.mode == 'cms_documents_catalogues')) {
                await search(true);
            }
        });
        const search = async (force = true) => {
            clearTimeout(searchTimeout.value);
            errorMessage.value = '';
            if (force != true) {
                if ((props.mode == 'cms_documents_dop') && query.value == 'DoP-') {
                    errorMessage.value = __('Wpisz numer deklaracji. Przykład poprawnego Nr DoP: DoP-16-0001-01');
                    return;
                }
                if ((props.mode == 'cms_documents_dop') && query.value.length == 0) {
                    errorMessage.value = __('Proszę podać numer deklaracji');
                    return;
                }
                if ((props.mode == 'cms_documents_dop') && !dopRegex.test(query.value.trim())) {
                    errorMessage.value = __('Numer deklaracji ma niepoprawny format. Przykład poprawnego Nr DoP: DoP-16-0001-01');
                    return;
                }
                if ((props.mode == 'cms_documents_dop') && Object.keys(dopLocales.value).length == 0) {
                    errorMessage.value = __('Nie znaleziono deklaracji!');
                    return;
                }
                if ((props.mode == 'cms_documents_dop') && !locale.value) {
                    errorMessage.value = __('Proszę wybrać język deklaracji');
                    return;
                }
                if ((props.mode != 'cms_documents_dop') && query.value.length == 0) {
                    errorMessage.value = __('Musisz podać wyszukiwaną frazę!');
                    return;
                }
            }
            if (locale.value == null || locale.value == '') {
                return;
            }
            try {
                const response = await axios.post(props.searchUrl + '/' + locale.value, {
                    query: query.value,
                    index: index.value,
                    size: size.value,
                    category: category.value
                });
                results.value = response.data.results;
                searchLocale.value = locale.value;
                totalPages.value = response.data.pages;
                totalResults.value = response.data.total;
                lastQuery.value = query.value;
                Array.isArray(response.data.results) && !response.data.results.length
                    ? noResults.value = true
                    : noResults.value = false;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'searching',
                    search_tab: query.value
                });
            }
            catch (error) {
                console.log('error', error);
            }
        };
        const reset = async () => {
            query.value = '';
            await search(true);
        };
        const changeIndex = (newIndex) => {
            index.value = newIndex;
        };
        const initDoPLocales = async () => {
            if ((props.mode != 'cms_documents_dop') || query.value.length == 0 || !dopRegex.test(query.value.trim())) {
                return;
            }
            try {
                const response = await axios.get(props.dopLocalesUrl, {
                    params: {
                        query: query.value,
                    }
                });
                dopLocales.value = response.data;
                locale.value = null;
                await nextTick(() => {
                    customSelect(true);
                });
            }
            catch (error) {
                console.log('error', error);
            }
        };
        watch(() => index.value, async () => {
            await search(true);
        });
        watch(() => category.value, async () => {
            await search(true);
        });
        watch(() => query.value, () => {
            clearTimeout(searchTimeout.value);
            if (query.value.length > 1)
                searchTimeout.value = setTimeout(search, 1000);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(mode) === 'cms_documents_dop' || _unref(mode) === 'default')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _renderSlot(_ctx.$slots, "breadcrumbs"),
                                _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.pageTitle), 1),
                                (_unref(mode) === 'cms_documents_dop')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(search, ["prevent"])
                                        }, [
                                            _createElementVNode("label", null, _toDisplayString(_unref(__)('Nr deklaracji')), 1),
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("div", _hoisted_8, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        placeholder: _unref(placeholder),
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((query).value = $event)),
                                                        onKeyup: initDoPLocales
                                                    }, null, 40, _hoisted_9), [
                                                        [_vModelText, query.value]
                                                    ])
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((locale).value = $event))
                                                }, [
                                                    _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(__)('Język deklaracji')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dopLocales.value, (value, index) => {
                                                        return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(value), 9, _hoisted_11));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, locale.value]
                                                ]),
                                                _createElementVNode("button", _hoisted_12, [
                                                    _createTextVNode(_toDisplayString(_unref(__)('Szukaj deklaracji')) + " ", 1),
                                                    _hoisted_13
                                                ])
                                            ])
                                        ], 40, _hoisted_6)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(mode) === 'default')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(search, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    placeholder: _unref(placeholder),
                                                    autocomplete: "off",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((query).value = $event))
                                                }, null, 8, _hoisted_17), [
                                                    [_vModelText, query.value]
                                                ]),
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    title: _unref(__)('Wyszukaj')
                                                }, _hoisted_20, 8, _hoisted_18)
                                            ])
                                        ], 40, _hoisted_15)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("p", null, _toDisplayString(_unref(errorMessage)), 1)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                    (_unref(mode) === 'cms_documents_catalogues')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(search, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            placeholder: _unref(placeholder),
                                            autocomplete: "off",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((query).value = $event))
                                        }, null, 8, _hoisted_26), [
                                            [_vModelText, query.value]
                                        ]),
                                        (query.value && query.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[4] || (_cache[4] = ($event) => (reset())),
                                                id: "search-delete-btn",
                                                "aria-label": _unref(__)('Resetuj wyszukiwanie'),
                                                title: _unref(__)('Resetuj wyszukiwanie'),
                                                type: "button"
                                            }, _hoisted_29, 8, _hoisted_27))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            title: _unref(__)('Wyszukaj')
                                        }, _hoisted_32, 8, _hoisted_30)
                                    ])
                                ], 40, _hoisted_24),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((category).value = $event))
                                }, [
                                    _createElementVNode("option", _hoisted_33, _toDisplayString(_unref(__)('Wybierz kategorię')), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (value, index) => {
                                        return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(value), 9, _hoisted_34));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, category.value]
                                ])
                            ]),
                            (_unref(errorMessage))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("p", null, _toDisplayString(_unref(errorMessage)), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ], 64))
                        : (totalResults.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createElementVNode("h2", null, [
                                    _createTextVNode(_toDisplayString(_unref(__)("Wyniki wyszukiwania dla języka ")) + " ", 1),
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(searchLocale.value), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                    (totalResults.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_unref(mode) == 'default')
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "page-result",
                                            key: index
                                        }, [
                                            (result.image != '')
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: result.image || _unref(asset)('images/placeholder-tf-green.svg'),
                                                    alt: result.title,
                                                    width: "630",
                                                    height: "250"
                                                }, null, 8, _hoisted_39))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h3", _hoisted_40, _toDisplayString(result.title), 1),
                                                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(__)('Strona główna')) + " / " + _toDisplayString(result.link?.path), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: "description",
                                                innerHTML: result.description
                                            }, null, 8, _hoisted_42),
                                            _createElementVNode("a", {
                                                href: result.link?.url,
                                                class: "btn btn-green",
                                                title: `${result.title}`
                                            }, _toDisplayString(_unref(__)('Czytaj więcej')), 9, _hoisted_43)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("ul", {
                                    key: 1,
                                    class: _normalizeClass(["results", { 'grid-layout': _unref(mode) != 'cms_documents_dop' }])
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "result",
                                            key: index
                                        }, [
                                            _createElementVNode("a", {
                                                href: result.link?.url,
                                                download: "",
                                                class: "btn-green-light btn--icon btn--fill",
                                                title: `${_unref(__)('Pobierz')} ${result.link?.path}`
                                            }, _hoisted_46, 8, _hoisted_44),
                                            _createElementVNode("a", {
                                                href: result.link?.url,
                                                class: "name"
                                            }, _toDisplayString(result.title), 9, _hoisted_47),
                                            (_unref(mode) == 'cms_documents_dop')
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: result.link?.url,
                                                    download: "",
                                                    class: "btn btn-green"
                                                }, _toDisplayString(_unref(__)("Pobierz DOP")), 9, _hoisted_48))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ], 2)),
                            _createVNode(Pagination, {
                                "page-index": index.value,
                                "total-pages": totalPages.value,
                                "max-size": 7,
                                onPageIndexChanged: _cache[6] || (_cache[6] = ($event) => (changeIndex($event)))
                            }, null, 8, ["page-index", "total-pages"])
                        ], 64))
                        : (noResults.value && query.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(__)('Nie znaleziono wyników')), 1))
                            : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
